module.exports = __webpack_public_path__ + "img/69186f2018f37fe9dcfc74b25a7837cd.svg";